import './App.css';
import Template from './template/template';

function App() {
  return (
    <div className="App">
	<Template></Template>
    </div>
  );
}

export default App;
